export type AnalyticsGoal =
  | 'daily_card_open'
  | 'pick_done'
  | 'pick_extra'
  | 'pick_choose'
  | 'card_rated'
  | 'personal_arcana_set'
  | 'reading_ordered'
  | 'login'
  | 'identity_linked'
  | 'sign_up'
  | 'topup_start'
  | 'topup_paid'
  | 'gift_created'
  | 'gift_claimed'

type Ym = {
  (id: number, method: string, ...args: unknown[]): void
  a?: unknown[]
}

declare global {
  interface Window {
    ym?: Ym
  }
}

let counterId: number | null = null

export function initAnalytics(rawId: string | undefined, surface: string, extra: Record<string, string> = {}): void {
  const id = Number(rawId)
  if (!Number.isInteger(id) || id <= 0 || counterId !== null) return
  counterId = id
  const queue: unknown[] = []
  const stub: Ym = (...args) => {
    queue.push(args)
  }
  stub.a = queue
  window.ym = stub
  const script = document.createElement('script')
  script.async = true
  script.src = `https://mc.yandex.ru/metrika/tag.js?id=${id}`
  document.head.append(script)
  stub(id, 'init', {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
    defer: true,
    params: { surface, ...extra },
  })
}

export function trackHit(url: string): void {
  if (counterId !== null) window.ym?.(counterId, 'hit', url)
}

export function trackGoal(goal: AnalyticsGoal, params?: Record<string, string | number | boolean>): void {
  if (counterId !== null) window.ym?.(counterId, 'reachGoal', goal, params)
}

const OAUTH_KEY = 'lunary.oauth_method'

export function rememberLoginMethod(method: string): void {
  try {
    sessionStorage.setItem(OAUTH_KEY, method)
  } catch {
    return
  }
}

export function takeLoginMethod(): string {
  try {
    const method = sessionStorage.getItem(OAUTH_KEY)
    sessionStorage.removeItem(OAUTH_KEY)
    return method ?? 'oauth'
  } catch {
    return 'oauth'
  }
}

type PaidPayment = { provider: string; lunars: number; amount: number; currency: string }

export function trackPaid(payment: PaidPayment): void {
  const params: Record<string, string | number> = { provider: payment.provider, lunars: payment.lunars, currency: payment.currency }
  if (payment.currency === 'RUB') params.order_price = payment.amount / 100
  else params.amount = payment.amount
  trackGoal('topup_paid', params)
}
